import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        // Scroll to top when the route changes
        // Use scrollTo(0, 0) for maximum browser compatibility
        window.scrollTo(0, 0);
        // Also try scrolling the document body/html for edge cases
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [pathname]);
    return null;
}
